import sampleProjectImage from '@/assets/images/sample-project.webp';

export default function ProjectsSection() {
  const projects = [
    {
      title: '2DK ゴミ屋敷清掃（東京都A様）',
      category: 'ゴミ屋敷清掃',
      image: sampleProjectImage,
      description: '足の踏み場もなかった2DKのお部屋が、2日間の作業ですっかり綺麗になりました。不用品の分別から搬出まで全て対応いたしました。'
    },
    {
      title: '3LDK 遺品整理（神奈川県B様）',
      category: '遺品整理',
      image: sampleProjectImage,
      description: '遠方にお住まいのご遺族様に代わり、丁寧に遺品の仕分けを行いました。思い出の品は形見分けとして配送いたしました。'
    },
    {
      title: 'ワンルーム 退去清掃（埼玉県C様）',
      category: '退去清掃',
      image: sampleProjectImage,
      description: '急な転勤で退去が必要になったお客様。不用品回収とハウスクリーニングをセットで行い、無事に引き渡しが完了しました。'
    },
    {
      title: '戸建て 不用品回収（千葉県D様）',
      category: '不用品回収',
      image: sampleProjectImage,
      description: '長年溜め込んでしまった家具や家電をまとめて回収。トラック3台分の不用品を処分し、広々とした空間が戻りました。'
    },
    {
      title: '特殊清掃 孤独死現場（東京都E様）',
      category: '特殊清掃',
      image: sampleProjectImage,
      description: '発見が遅れてしまった現場の消臭・消毒作業。オゾン脱臭機を使用し、臭いを完全に除去してから原状回復を行いました。'
    },
    {
      title: '生前整理（神奈川県F様）',
      category: '生前整理',
      image: sampleProjectImage,
      description: '施設への入居に伴う生前整理をお手伝い。必要なものと不要なものを一緒に選別し、新居へのお引越しもサポートしました。'
    }
  ];

  return (
    <section id="projects" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-pink-100 px-4 py-2 rounded-full mb-4">
            <i className="ri-gallery-line text-primary"></i>
            <span className="text-primary font-semibold text-sm">実績紹介</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            これまでの <strong className="text-primary">清掃実績</strong>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            どんな状態のお部屋でも、プロの技術で見違えるように綺麗にします。
            多数の実績の中から一部をご紹介します。
          </p>
        </div>

        {/* Projects Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {projects.map((project, index) => (
            <div 
              key={index}
              className="group bg-white rounded-2xl overflow-hidden border border-gray-200 hover:border-primary hover:shadow-xl transition-all duration-300"
            >
              <div className="relative w-full h-64 overflow-hidden">
                <img 
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute top-4 left-4">
                  <span className="px-3 py-1 bg-primary text-white text-xs font-semibold rounded-full">
                    {project.category}
                  </span>
                </div>
              </div>
              
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2">{project.title}</h3>
                <p className="text-gray-600 text-sm leading-relaxed">{project.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-12">
          <p className="text-gray-600 mb-4">あなたのお部屋も綺麗にしませんか？</p>
          <a 
            href="#contact"
            className="inline-flex items-center gap-2 px-8 py-4 bg-primary text-white font-semibold rounded-lg hover:bg-pink-600 transition-all shadow-lg whitespace-nowrap cursor-pointer"
          >
            無料お見積りはこちら
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}